import { ProductList } from './ProductList';
import { useNavigate } from 'react-router-dom';
import DetailsHeader from '../../siteDetails/header/DetailsHeader';
import Button from 'src/ui/wards/common/button/Button';
import { useTranslation } from 'react-i18next';
import { useWaProductStore } from 'src/api/wa/store/WaProductStore';
import useWaProductService from 'src/api/wa/service/WaProductService';
import { useEffect } from 'react';
import { useWaWorkplaceStore } from 'src/api/wa/store/WaWorkplaceStore';

const S_ProductNumberList = () => {
  const { fetchProducts, fetchProductMasterInfo } = useWaProductService();
  const { selectedWorkplace } = useWaWorkplaceStore();

  useEffect(() => {
    if (selectedWorkplace) {
      fetchProducts(selectedWorkplace);
      fetchProductMasterInfo(selectedWorkplace);
    }
  }, [fetchProductMasterInfo, fetchProducts, selectedWorkplace]);

  const { productMasterInfo, products } = useWaProductStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const productCount = productMasterInfo?.length ?? 0;

  const backNavigation = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-100 pt-4">
      <DetailsHeader
        siteName={t('wards.productList.title', {
          count: productCount,
        })}
      />
      <div className="p-4">
        <Button title={t('wards.common.back')} onClick={backNavigation} />
      </div>
      <ProductList productMasterInfo={productMasterInfo} products={products} />
      <div className="p-4">
        <Button title={t('wards.common.back')} onClick={backNavigation} />
      </div>
    </div>
  );
};

export default S_ProductNumberList;
